var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelephone = function SvgTelephone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m15.694 12.794 3.678 2.044c.528.293.76.915.552 1.482-1.055 2.881-4.144 4.402-7.05 3.341C6.92 17.49 2.51 13.077.336 7.125-.723 4.22.797 1.13 3.68.075A1.21 1.21 0 0 1 5.16.626l2.043 3.679c.32.575.245 1.257-.193 1.748q-.858.968-1.717 1.932c1.222 2.975 3.744 5.497 6.72 6.719l1.93-1.717a1.5 1.5 0 0 1 1.75-.193",
    clipRule: "evenodd"
  })));
};
export default SvgTelephone;